import { connect } from 'react-redux';
import ServiceOptions from './ServiceOptions';
import { addOptionToNewOffer, validateSelectedOptions } from '../../../modules/NewOffer/actions';
import { newOfferOptionsSelector } from '../../../modules/NewOffer/selectors';
import { availableServiceOptionsSelector } from '../../../modules/AvailableOption/selectors';

const mapStateToProps = state => ({
  options: availableServiceOptionsSelector(state),
  priceKey: 'taxIncludedAmount',
  selectedOptions: newOfferOptionsSelector(state),
});

const mapDispatchToProps = {
  validateSelectedOptions,
  addOptionToNewOffer,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceOptions);
